import { Injectable } from '@angular/core';
import { StaticContent } from '@models/static-content.model';
import { ApiResponse, ApiService } from './api.service';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ContentService {
  private content: StaticContent[] = [];

  constructor(
    private apiService: ApiService
  ) { }

  setContent(content: StaticContent[]) {
    this.content = content;
  }

  getCustomPolicies(): StaticContent[] {
    return this.content.filter((c: StaticContent) => {
      return c.type === 'policy' && ['privacy_policy', 'terms_conditions'].indexOf(c.short_code) === -1;
    });
  }

  getMyPolices(): Observable<ApiResponse<StaticContent[]>> {
    return this.apiService.get<ApiResponse<StaticContent[]>>(`my-policies`);
  }

  getContentByShortCode(shortCode: string): StaticContent | undefined {
    return this.content.find((sc: StaticContent) => sc.short_code === shortCode);
  }

  getContentsByShortCode(shortCode: string): StaticContent[] | undefined {
    return this.content.filter((sc: StaticContent) => sc.short_code === shortCode);
  }

  getContentsByType(type: string): StaticContent[] {
    return this.content.filter((sc: StaticContent) => sc.type === type);
  }
}
